import React, { useEffect, useState } from "react";
import { getMessages } from "services/dashboard.services";
import LoadingPage from "views/LoadingPage";
import { useSelector } from "react-redux";
import { useModal } from "context";
import { eyeIcon } from "assets/icons";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { NoResultsSection } from "reusableComponents";

const MessagesList = () => {
  const { t } = useTranslation("global");
  const { openModal } = useModal();
  const [error, setError] = useState(null);
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    const fetchMessages = async () => {
      setLoading(true);
      setError(null);

      try {
        const data = await getMessages(token);
        setMessages(data || []); // Handle empty data gracefully
      } catch (err) {
        setError(err.message || t("dashboard.messages.fetchError"));
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [token, t]);

  const handleOpenModal = (subject, bodyContent) => {
    openModal({
      content: <p dangerouslySetInnerHTML={{ __html: bodyContent }} />,
      title: subject,
  
      size: "medium", // Assuming 700 is a size, otherwise use "small", "medium", or "large"
    });
    
  };

  if (error)
    return (
      <div className={styles.error}>
        <p>{error}</p>
      </div>
    );

  return (
    <div
    className={`${styles.messagesPage} ${
      loading ? styles.loading : ""
    }`}
  >        <h2 className={styles.messagesTitle}>{t("dashboard.messages.title")}</h2>
      {messages.length > 0 ? (
        <div className={styles.messagesList}>
          {messages.map((message) => (
            <div key={message.id} className={styles.messageItem}>
              <h3 className={styles.messageSubject}>{message.subject}</h3>
              <p className={styles.messageDate}>
                {new Date(message.created_at?.date || message.created_at).toLocaleDateString()}
              </p>
              <button
                className={styles.eyeIcon}
                onClick={() => handleOpenModal(message.subject, message.body)}
                aria-label={`View message: ${message.subject}`}
              >
                <img src={eyeIcon} alt={t("dashboard.messages.viewMessage")} />
              </button>
            </div>
          ))}
        </div>
      ) : (
        <NoResultsSection
          title={t("dashboard.messages.noResultTitle")}
          text={t("dashboard.messages.noResultText")}
        />
      )}
    </div>
  );
};

export default MessagesList;
